<template>
    <header>
        <a href="http://www.sivec.lu/" class="back-button"><img src="../assets/ui/arrow-back.svg"  alt=""> {{ t('Retour à la page web')}}</a>
        <div class="wrap">
            <img src="../assets/logo.svg" class="logo" alt="">
            <p>Syndicat Intercommunal à Vocation ECologique</p>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'Header'
    }
</script>

<style scoped>
    .back-button {
        border-bottom-right-radius: 30px;
        box-shadow: 1px 1px 10px 2px rgba(48, 71, 29, 0.08);
        color: var(--green--dark);
        font-weight: 700;
        padding: var(--xmedium) 80px var(--xmedium) 50px;
        position: absolute;
        top: 0;
        left: 0;
        transition: color 0.2s ease;
    }

    @media print {
        .back-button {
            display: none;
        }
    }

    @media only screen and (max-width: 500px) {
        .back-button {
            border-bottom-right-radius: 0;
            text-align: center;
            padding: var(--medium);
            width: 100%;
        }
    }

    .back-button:hover {
        color: var(--green);
    }

    .logo {
        height: 110px;
        margin-right: var(--xmedium);
    }

    @media only screen and (max-width: 500px) {
        .logo {
            height: 45px;
            margin-right: var(--medium);
        }
    }

    @media print {
        .logo {
            height: 45px;
            filter: grayscale(100%);
        }
    }

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: var(--xxlarge) auto var(--xlarge);
    }

    p {
        color: var(--green--black);
        font-family: montserrat,sans-serif;
        font-size: 38px;
        font-weight: 800;
    }

    @media print {
        p {
            font-size: 20px;
        }
    }

    @media only screen and (max-width: 650px) {
        p {
            font-size: 24px;
        }
    }

    @media only screen and (max-width: 500px) {
        div {
            margin: var(--xlarge) auto var(--small);
        }

        p {
            font-size: 18px;
        }
    }
</style>
